import clsx from "clsx";

import DottedSeparator from "common/components/DottedSeparator";

import type { ReactNode } from "react";

export default function SettingsItemContainer({
  children,
  className,
}: {
  children: ReactNode;
  className?: string;
}) {
  return (
    <div className="flex flex-col w-full group/item-container">
      <DottedSeparator className="group-first/item-container:hidden" />
      <div
        className={clsx(
          "flex w-full py-4 max-lg:group-first/item-container:pt-0",
          className,
        )}
      >
        {children}
      </div>
    </div>
  );
}
